import { useEffect, useState } from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

import { default as Logo } from '@plone/volto/components/theme/Logo/Logo';
import { default as ConditionalLink } from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { default as UniversalLink } from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import {
  faArrowRightFromBracket,
  faUser,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MobileNavigation from '@kitconcept/volto-light-theme/components/MobileNavigation/MobileNavigation';

import { getItemsByPath } from 'volto-dropdownmenu/utils';
import logobasque from './BasqueAudiovisual.svg';

import cx from 'classnames';
// SemanticUI-free pre-@plone/components
import PropTypes from 'prop-types';

const messages = defineMessages({
  siteLabel: {
    id: 'siteLabel',
    defaultMessage: ' ',
  },
  basque: {
    id: 'basque',
    defaultMessage: 'Basque Audiovisual',
  },
  privatearea: {
    id: 'privatearea',
    defaultMessage: 'Private area',
  },
});

const InternetHeader = ({ pathname, siteLabel, token, siteAction, locale }) => {
  const intl = useIntl();
  const user = useSelector((state) => state.users.user);
  const dropdownMenuNavItems = useSelector(
    (state) => state.dropdownMenuNavItems?.result,
  );
  const menu = getItemsByPath(dropdownMenuNavItems, `/${locale}/pre-header`);

  return (
    <>
      <div className="basque-audiovisual-header">
        {/* <LanguageSelector /> */}
        <UniversalLink
          href={`https://www.basqueaudiovisual.eus/${locale === 'eu' ? 'eu/hasiera' : locale === 'es' ? 'es/inicio' : locale === 'en' ? 'en/home' : 'eu/hasiera'}`}
        >
          <img
            src={logobasque}
            alt={intl.formatMessage(messages.basque)}
            title={intl.formatMessage(messages.basque)}
          />
        </UniversalLink>
        <div className="links">
          {menu &&
            menu.map((section, index) => (
              <span key={index}>
                <ConditionalLink
                  condition={flattenToAppURL(section.linkUrl?.[0]?.['@id'])}
                  href={flattenToAppURL(section.linkUrl?.[0]?.['@id'])}
                >
                  {section.nav_title || section.title}
                </ConditionalLink>
              </span>
            ))}
        </div>
      </div>
      <div className="floating-border">
        <div className=" top"></div>
        <div className=" right"></div>
        <div className=" bottom"></div>
        <div className=" left"></div>
      </div>
      <div className="header">
        <div className="logo-nav-wrapper">
          <div className="logo">
            <Logo />
          </div>

          <div className="private-area">
            {token ? (
              <Dropdown
                multiple
                trigger={
                  <>
                    <FontAwesomeIcon
                      style={{ maxWidth: '15px', height: '1em' }}
                      className="primary"
                      icon={faUser}
                    />{' '}
                    {token ? (
                      <>
                        {user.fullname}{' '}
                        <FontAwesomeIcon
                          style={{ maxWidth: '15px', height: '1em' }}
                          icon={faChevronDown}
                        />
                      </>
                    ) : (
                      <FormattedMessage
                        id="Private area"
                        defaultMessage="Private area"
                      />
                    )}
                  </>
                }
              >
                <Dropdown.Menu>
                  <Dropdown.Menu scrolling>
                    <Dropdown.Item
                      text={
                        <UniversalLink href={`/${locale}/private-area`}>
                          <FontAwesomeIcon
                            style={{ maxWidth: '15px', height: '1em' }}
                            className="primary"
                            icon={faUser}
                          />{' '}
                          <FormattedMessage
                            id="Private area"
                            defaultMessage="Private area"
                          />
                        </UniversalLink>
                      }
                    />
                    <Dropdown.Item
                      text={
                        <UniversalLink href={`/${locale}/logout`}>
                          <FontAwesomeIcon
                            style={{ maxWidth: '15px', height: '1em' }}
                            className="danger"
                            icon={faArrowRightFromBracket}
                          />
                          <FormattedMessage
                            id="Log out"
                            defaultMessage="Log out"
                          />
                        </UniversalLink>
                      }
                    />
                  </Dropdown.Menu>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <UniversalLink href={`/${locale}/login?return_url=${pathname}`}>
                <FontAwesomeIcon
                  style={{ maxWidth: '15px', height: '1em' }}
                  className="primary"
                  icon={faUser}
                />{' '}
                <FormattedMessage
                  id="Private area"
                  defaultMessage="Private area"
                />
              </UniversalLink>
            )}{' '}
          </div>

          <MobileNavigation token={token} locale={locale} pathname={pathname} />
        </div>
      </div>
    </>
  );
};

const Header = (props) => {
  const { pathname } = props;
  let siteLabel = config.settings.siteLabel;
  const token = useSelector((state) => state.userSession.token);
  const locale = useSelector((state) => state.intl.locale);
  const siteAction = useSelector(
    (state) => state.content.data?.['@components']?.actions?.site_actions,
  );
  const intl = useIntl();
  const translatedSiteLabel = intl.formatMessage(messages.siteLabel);
  const [small, setSmall] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', () => setSmall(window.scrollY > 1));
    }
  }, []);
  siteLabel =
    siteLabel &&
    (translatedSiteLabel !== 'siteLabel' && translatedSiteLabel !== ' '
      ? translatedSiteLabel
      : siteLabel);

  return (
    <header className={cx('header-wrapper', { 'small-header': small })}>
      <InternetHeader
        pathname={pathname}
        siteLabel={siteLabel}
        token={token}
        locale={locale}
        siteAction={siteAction}
      />
    </header>
  );
};

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
};

Header.defaultProps = {
  token: null,
};

export default Header;
